function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import * as ActionType from '../ActionType';
var initialState = {
    currentCampaignIdentifier: null,
    currentCampaignIdentifierLoading: false,
    currentCampaignIdentifierError: '',
    campaignsByIdentifier: {},
    campaignsLoading: false,
    campaignsError: ''
};
export var getCurrentCampaign = function(state) {
    return {
        data: state.campaign.campaignsByIdentifier[state.campaign.currentCampaignIdentifier],
        loading: state.campaign.currentCampaignIdentifierLoading,
        error: state.campaign.currentCampaignIdentifierError
    };
};
export var getCurrentCampaignTapSurvey = function(state) {
    return {
        data: state.campaign.campaignsByIdentifier[state.campaign.currentCampaignIdentifier] && state.campaign.campaignsByIdentifier[state.campaign.currentCampaignIdentifier].tap_survey,
        loading: state.status.LOAD_CAMPAIGN_TAP_SURVEY.loading,
        error: state.status.LOAD_CAMPAIGN_TAP_SURVEY.error
    };
};
export default function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case ActionType.RESET_CURRENT_CAMPAIGN:
            {
                return _object_spread_props(_object_spread({}, state), {
                    currentCampaignIdentifier: null,
                    currentCampaignIdentifierLoading: false,
                    currentCampaignIdentifierError: ''
                });
            }
        case ActionType.LOAD_CAMPAIGN_FEASIBILITY_SUCCESS:
            {
                var _action_payload = action.payload, identifier = _action_payload.identifier, feasibility = _action_payload.feasibility;
                return _object_spread_props(_object_spread({}, state), {
                    campaignsByIdentifier: _object_spread_props(_object_spread({}, state.campaignsByIdentifier), _define_property({}, identifier, _object_spread_props(_object_spread({}, state.campaignsByIdentifier[identifier]), {
                        feasibility: feasibility
                    })))
                });
            }
        case ActionType.LOAD_CAMPAIGN_REQUEST:
            {
                return _object_spread_props(_object_spread({}, state), {
                    currentCampaignIdentifierLoading: true,
                    currentCampaignIdentifierError: ''
                });
            }
        case ActionType.LOAD_CAMPAIGN_SUCCESS:
            {
                var campaign = action.payload.campaign;
                return _object_spread_props(_object_spread({}, state), {
                    currentCampaignIdentifier: campaign.identifier,
                    currentCampaignIdentifierLoading: false,
                    currentCampaignIdentifierError: '',
                    campaignsByIdentifier: _object_spread_props(_object_spread({}, state.campaignsByIdentifier), _define_property({}, campaign.identifier, _object_spread({}, state.campaignsByIdentifier[campaign.identifier], campaign)))
                });
            }
        case ActionType.LOAD_CAMPAIGN_FAILURE:
            {
                var error = action.payload.error;
                return _object_spread_props(_object_spread({}, state), {
                    currentCampaignIdentifierLoading: false,
                    currentCampaignIdentifierError: error
                });
            }
        case ActionType.SAVE_CAMPAIGN_FAILURE:
            {
                var error1 = action.payload.error;
                return _object_spread_props(_object_spread({}, state), {
                    saveError: error1,
                    saveLoading: false
                });
            }
        case ActionType.LOAD_CAMPAIGN_TAP_SURVEY_SUCCESS:
            {
                var _action_payload1 = action.payload, tapSurvey = _action_payload1.tapSurvey, campaignIdentifier = _action_payload1.campaignIdentifier;
                return _object_spread_props(_object_spread({}, state), {
                    campaignsByIdentifier: _object_spread_props(_object_spread({}, state.campaignsByIdentifier), _define_property({}, campaignIdentifier, _object_spread_props(_object_spread({}, state.campaignsByIdentifier[campaignIdentifier]), {
                        tap_survey: _object_spread({}, state.campaignsByIdentifier[campaignIdentifier].tap_survey, tapSurvey)
                    })))
                });
            }
        default:
            return state;
    }
}
